const formatPermissions = (permissions, permissionList) =>
  Object.fromEntries(
    Object.keys(permissions).map((key) => [
      key,
      permissions[key]
        .map((id) => permissionList.find((item) => item.uid === String(id))?.id)
        .filter((id) => !!id),
    ]),
  );

module.exports = {
  formatPermissions,
};
